function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable max-statements */
import React from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useTypedSelector } from 'src/redux/utils';
import styles from './styles.module.scss';
import thetanLogo from 'assets/img/thetan_logo_V2.png';
import dotBackground from 'assets/img/dot_background_V2.png';
import icClose from 'assets/svg/ic_close_black.svg';
import imgGift from 'assets/img/img_gift.png';
import Button from 'src/Components/Button_V2';
import classNames from 'classnames';
import { webImageUri } from 'src/utils/uri';
import ProfilePanel from '../ProfilePanel';
import { MKPTab } from 'src/models';
import { RouteName } from 'src/routes/config';
import ImageWithPlaceholder from 'src/Components/ImageWithPlaceholder';
import CalloutContent from 'src/Components/CalloutProvider/CalloutContent';
import { useCallout } from 'src/Components/CalloutProvider';
import { cryptoBuy } from '../../config';
import { ALCHEMYPAY_CONFIG } from 'src/constants';
import { AppError } from 'src/redux/types';
import PageContent from 'src/Components/PageContent';
import Skeleton from 'src/Components/Skeleton';
import { getSession } from 'src/utils/session';
import { useTestId } from '@wolffun/testable-id';
import { signAlchemyPaySignature } from '@main/src/utils/crypto';
import { currencyIconMap, currencyName } from '@wolffun/shared/src/types';
import listWallet from 'assets/svg/list_wallet.svg';

const HeaderDesktop = ({
  avatar,
  avatarFrame
}) => {
  var _getSession;

  const {
    generateTestIdProps
  } = useTestId();
  const {
    user: profile,
    loading,
    error,
    invalidated
  } = useTypedSelector(state => state.userProfile);
  const connectWalletCampaign = useTypedSelector(state => {
    var _state$thetanWorldCon;

    return (_state$thetanWorldCon = state.thetanWorldConfig.data) === null || _state$thetanWorldCon === void 0 ? void 0 : _state$thetanWorldCon.connectWallet;
  });
  const {
    loading: loadingCallout,
    error: errorCallout,
    invalidated: invalidatedCallout
  } = useTypedSelector(state => state.listNotification);
  const {
    pathname
  } = useLocation();
  const history = useHistory();
  const {
    resetCallout
  } = useCallout();
  const signedIn = !!((_getSession = getSession()) !== null && _getSession !== void 0 && _getSession.accessToken);
  const ref = React.useRef(null);
  const refGetTHC = React.useRef(null);
  const profileSettingsRef = React.useRef(null);
  const [showOnramp, setShowOnramp] = React.useState(false);
  const [typeCryptoBuy, setTypeCryptoBuy] = React.useState();

  const closeOnramp = () => {
    setShowOnramp(false);
    setTypeCryptoBuy(undefined);
  };

  const renderOnramp = () => {
    if (!(profile !== null && profile !== void 0 && profile.address)) {
      return null;
    }

    const signature = signAlchemyPaySignature(ALCHEMYPAY_CONFIG.appId, ALCHEMYPAY_CONFIG.secret, profile === null || profile === void 0 ? void 0 : profile.address);
    const url = `${ALCHEMYPAY_CONFIG.endpoint}/?appId=${ALCHEMYPAY_CONFIG.appId}&address=${profile === null || profile === void 0 ? void 0 : profile.address}&sign=${signature}&crypto=${typeCryptoBuy ? currencyName[typeCryptoBuy] : ''}&network=BSC`;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.chooseCrypto
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.dropBack,
      onClick: closeOnramp
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.transakWrapper
    }, /*#__PURE__*/React.createElement("div", {
      onClick: closeOnramp,
      className: styles.close
    }, /*#__PURE__*/React.createElement("img", {
      src: icClose,
      alt: "close"
    })), !typeCryptoBuy ? /*#__PURE__*/React.createElement("div", {
      className: styles.content
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.chooseCryptoTitle
    }, "Choose crypto"), /*#__PURE__*/React.createElement("span", {
      className: styles.chooseCryptoDesc
    }, "Please choose the cryptocurrency for purchase"), /*#__PURE__*/React.createElement("div", {
      className: styles.chooseCryptoGroupBtn
    }, cryptoBuy.map(item => /*#__PURE__*/React.createElement(Button, {
      title: `Buy ${currencyName[item]}`,
      icon: currencyIconMap[item],
      className: styles.chooseCryptoBtn,
      key: item,
      onClick: () => setTypeCryptoBuy(item)
    }))), /*#__PURE__*/React.createElement("img", {
      src: listWallet,
      alt: "icon",
      className: styles.listWallet
    })) : /*#__PURE__*/React.createElement("iframe", {
      title: "AlchemyPay On Ramp Widget",
      src: url,
      frameBorder: "no",
      allow: "payment",
      allowFullScreen: false,
      className: styles.iframeTransak
    })));
  };

  const renderUserProfile = () => {
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: styles.rightContainer
    }, /*#__PURE__*/React.createElement("div", {
      ref: refGetTHC,
      className: styles.getThcBtn,
      onClick: () => setShowOnramp(true)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.textGetThc
    }, "Buy Crypto")), /*#__PURE__*/React.createElement("div", _extends({
      className: styles.avatarContainer
    }, generateTestIdProps('user-avatar')), avatar && /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
      onClick: e => {
        var _profileSettingsRef$c, _ref$current, _ref$current$getBound;

        e.stopPropagation();
        (_profileSettingsRef$c = profileSettingsRef.current) === null || _profileSettingsRef$c === void 0 ? void 0 : _profileSettingsRef$c.toggleDropdown({
          top: 20 + (((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : (_ref$current$getBound = _ref$current.getBoundingClientRect()) === null || _ref$current$getBound === void 0 ? void 0 : _ref$current$getBound.bottom) || 0),
          right: 32
        });
      },
      className: styles.avatar,
      src: webImageUri(avatar.imageAvatar),
      renderPlaceholder: () => /*#__PURE__*/React.createElement(Skeleton, {
        className: styles.avatar
      })
    }), avatarFrame && /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
      onClick: e => {
        var _profileSettingsRef$c2, _ref$current2, _ref$current2$getBoun;

        e.stopPropagation();
        (_profileSettingsRef$c2 = profileSettingsRef.current) === null || _profileSettingsRef$c2 === void 0 ? void 0 : _profileSettingsRef$c2.toggleDropdown({
          top: 20 + (((_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : (_ref$current2$getBoun = _ref$current2.getBoundingClientRect()) === null || _ref$current2$getBoun === void 0 ? void 0 : _ref$current2$getBoun.bottom) || 0),
          right: 32
        });
      },
      className: styles.avatarFrame,
      src: webImageUri(avatarFrame),
      renderPlaceholder: () => /*#__PURE__*/React.createElement(Skeleton, {
        className: styles.avatar
      })
    })));
  };

  const renderContentWalletBtn = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.rightContainer
    }, /*#__PURE__*/React.createElement(Button, _extends({}, generateTestIdProps('connect-wallet-button'), {
      onClick: () => {
        history.push(RouteName.Login);
      },
      className: styles.connectButton,
      title: "Connect Wallet",
      uppercase: false,
      renderRightIcon: () => connectWalletCampaign ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: styles.fakeGift
      }), /*#__PURE__*/React.createElement("img", {
        src: imgGift,
        className: styles.imgGift
      })) : null
    })));
  };

  const renderTab = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
      onClick: () => {
        resetCallout(MKPTab.Dashboard);
      },
      className: styles.marketplace,
      to: RouteName.HomeDashboard
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.label, styles.navLink, [RouteName.HomeDashboard.toString(), RouteName.Dashboard.toString()].includes(pathname) && styles.active)
    }, /*#__PURE__*/React.createElement(CalloutContent, {
      calloutTab: MKPTab.Dashboard
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.liveDot
    })), /*#__PURE__*/React.createElement("span", {
      className: styles.txtSpan
    }, "Dashboard"))), /*#__PURE__*/React.createElement(Link, {
      onClick: () => {
        resetCallout(MKPTab.Buy);
      },
      className: styles.marketplace,
      to: RouteName.MarketPlace
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.label, styles.navLink, pathname === RouteName.MarketPlace && styles.active)
    }, /*#__PURE__*/React.createElement(CalloutContent, {
      calloutTab: MKPTab.Buy
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.liveDot
    })), /*#__PURE__*/React.createElement("span", {
      className: styles.txtSpan
    }, "Buy"))), /*#__PURE__*/React.createElement(Link, {
      onClick: () => {
        resetCallout(MKPTab.Staking);
      },
      className: styles.marketplace,
      to: RouteName.Staking
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.label, styles.navLink, [RouteName.Staking.toString(), RouteName.YourStaking.toString()].includes(pathname) && styles.active)
    }, /*#__PURE__*/React.createElement(CalloutContent, {
      calloutTab: MKPTab.Staking
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.liveDot
    })), /*#__PURE__*/React.createElement("span", {
      className: styles.txtSpan
    }, "Staking"))), /*#__PURE__*/React.createElement(Link, {
      onClick: () => {
        resetCallout(MKPTab.VestingSafe);
      },
      className: styles.marketplace,
      to: RouteName.VestingSafe
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.label, styles.navLink, pathname === RouteName.VestingSafe && styles.active)
    }, /*#__PURE__*/React.createElement(CalloutContent, {
      calloutTab: MKPTab.VestingSafe
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.liveDot
    })), /*#__PURE__*/React.createElement("span", {
      className: styles.txtSpan
    }, "Vesting Safe"))));
  };

  const renderHeaderLoading = () => /*#__PURE__*/React.createElement(Skeleton, {
    className: styles.loadingTab
  });

  const renderLoading = () => /*#__PURE__*/React.createElement(Skeleton, {
    className: classNames(styles.rightContainer, styles.skeleton)
  });

  return /*#__PURE__*/React.createElement(React.Fragment, null, showOnramp && renderOnramp(), /*#__PURE__*/React.createElement("div", _extends({
    className: styles.root
  }, generateTestIdProps('container')), /*#__PURE__*/React.createElement("div", {
    className: styles.leftContainer
  }, /*#__PURE__*/React.createElement(Link, {
    className: styles.marketplace,
    to: RouteName.HomeDashboard
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.label, styles.home)
  }, /*#__PURE__*/React.createElement("img", {
    src: thetanLogo,
    className: styles.logo
  }), /*#__PURE__*/React.createElement("img", {
    src: dotBackground,
    className: styles.dotBackground
  }))), /*#__PURE__*/React.createElement(PageContent, {
    error: errorCallout !== AppError.NO_ERROR,
    loading: loadingCallout,
    invalidated: invalidatedCallout,
    renderContent: renderTab,
    renderError: renderHeaderLoading,
    renderLoading: renderHeaderLoading
  })), signedIn ? /*#__PURE__*/React.createElement(PageContent, {
    error: error !== AppError.NO_ERROR,
    loading: loading,
    invalidated: invalidated,
    renderContent: renderUserProfile,
    renderError: renderLoading,
    renderLoading: renderLoading
  }) : renderContentWalletBtn()), /*#__PURE__*/React.createElement("div", {
    className: styles.headerFake
  }), /*#__PURE__*/React.createElement(ProfilePanel, {
    ref: profileSettingsRef
  }));
};

export default HeaderDesktop;